import React from 'react';
import { Input } from 'app/components/ui/input';
import { Label } from 'app/components/ui/label';
import { useFormContext } from 'react-hook-form';

function Details() {
  const form = useFormContext();

  return (
    <>
      <div className="bg-white  dark:bg-transparent rounded-lg p-4 mb-6">
        {/* Course Name */}
        <div className="py-2">
          <Label htmlFor="course-name">Course Name </Label>
          <Input
            id="course-name"
            placeholder="Enter Course Name"
            type="text"
            {...form.register('title', {
              required: 'Course Name is required',
            })}
            onChange={e => {
              form.setValue(
                'slug',
                e.target.value.toLowerCase().replace(/ /g, '-'),
              );
            }}
          />
          {form?.formState?.errors?.title && (
            <p className="text-red-500 text-xs mt-1">
              {form?.formState?.errors.title.message}
            </p>
          )}
        </div>

        <div className="py-2">
          <Label htmlFor="slug">Slug </Label>
          <Input
            id="slug"
            placeholder="Enter Slug"
            type="text"
            {...form.register('slug', {
              required: 'Course Slug is required',
            })}
          />
          {form?.formState?.errors?.slug && (
            <p className="text-red-500 text-xs mt-1">
              {form?.formState?.errors.slug.message}
            </p>
          )}
        </div>

        {/* Subtitle */}
        <div className="py-2">
          <Label htmlFor="subtitle">Subtitle/Headline </Label>
          <Input
            id="subtitle"
            placeholder="Enter Subtitle"
            type="text"
            {...form.register('subtitle', {
              required: 'Subtitle is required',
            })}
          />
        </div>
      </div>
    </>
  );
}

export default Details;
